import { Item } from "./Item";

export interface Divider extends Item {
  type: "Divider";
}

export function isDivider(obj: object): obj is Divider {
  return typeof obj === "object" && "type" in obj && obj.type === "Divider";
}
